<div class="main-container" [ngClass]="{ banner: service.isMimicUser$ | async }">
  <oiq-v2-layout
    *ngIf="!isSwitching"
    [menu]="menu"
    [settingsMenu]="settingsMenu"
    [isImpersonated]="isImpersonated()"
    [account]="service.account$ | async"
    [brandImg]="service.logo$ | async"
    [logoType]="getLogoType(service.logo$ | async)"
    (logout)="service.handleLogout()"
    (searched)="service.handleSearch($event)"
    [isEmpty]="isStandaloneRoute"
    [emailAppEnabled]="
      !!(tenantSettings$ | async)?.features?.TwoWayEmails &&
      authService.userHasAccessToResources('two-way-emails') &&
      (has2WayEmailRole$ | async)
    "
    [isLoading]="isSwitching">
  </oiq-v2-layout>
</div>
